import { useState } from "react";
import { toast } from "sonner";
import { Mic } from "lucide-react";
import { VoiceRecorder } from "@/components/VoiceRecorder";

export const VoiceReply = ({ replyTo, onSent }) => {
  const [open, setOpen] = useState(false);
  const [sent, setSent] = useState(false);
  if (sent) return <div className="ss" style={{ marginTop: 6 }} data-testid={`voice-reply-sent-${replyTo}`}>Voice reply sent ✓ — your coach has been notified.</div>;
  if (!open) return <button className="btn sm g" style={{ marginTop: 6 }} onClick={() => setOpen(true)} data-testid={`voice-reply-button-${replyTo}`}><Mic size={12} style={{ verticalAlign: -1, marginRight: 5 }} />Reply with voice</button>;
  return (
    <div style={{ marginTop: 6 }} data-testid={`voice-reply-${replyTo}`}>
      <VoiceRecorder value={null} endpoint="/client/me/voice-reply" extra={{ replyTo }} label="Your voice reply · up to 20s · sends when you stop"
        onChange={(r) => { if (r) { setSent(true); toast.success("Voice reply sent to your coach"); onSent?.(); } }} />
      <button className="linkbtn" onClick={() => setOpen(false)} data-testid={`voice-reply-cancel-${replyTo}`}>Cancel</button>
    </div>
  );
};
